export { default } from "./productItem";
